import Loadable from '../../../../components/loadable';
import prerenderedLoadable from '../../../../components/prerender';

const Page = Loadable(() =>
  import(
    /* webpackChunkName: "business-product-ar-watch" */ './index'
    )
);

export default prerenderedLoadable(Page);
